/**
 * DevExtreme (esm/__internal/scheduler/r1/components/const.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const DefaultSizes = {
  allDayPanelHeight: 25
};
export const DATE_TABLE_CELL_CLASS = "dx-scheduler-date-table-cell";
export const DATE_TABLE_ROW_CLASS = "dx-scheduler-date-table-row";
export const ALL_DAY_PANEL_CELL_CLASS = "dx-scheduler-all-day-table-cell";